import { GET_GAME_DETAIL, GET_GAME_DETAIL_FAILURE, GET_GAME_DETAIL_SUCCESS, SET_GAME_NAME } from "../constants"

const initialState = {
    isLoading: false,
    gameName: ''
}

export default function GameDetailReducer(state = initialState, action) {
    switch (action.type) {
        case GET_GAME_DETAIL:
            state = {
                ...state,
                isLoading: true
            }
            break;
        case GET_GAME_DETAIL_SUCCESS:
            state = {
                ...state,
                isLoading: false
            }
            break;
        case GET_GAME_DETAIL_FAILURE:
            state = {
                ...state,
                isLoading: false
            }
            break;
        case SET_GAME_NAME:
            state = {
                ...state,
                gameName: action.payload
            }
        default:
            break;
    }
    return state
}